export * from './auth/auth';
export * from './auth/auth.module';
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/auth.js
// module id = ./node_modules/angularfire2/auth.js
// module chunks = 3